import React from 'react'
import styled from 'styled-components'
import { PageContext } from 'types/PageContext'
import { PageMeta } from 'lib/PageMeta'
import { Page } from 'modules/Page'
import { BrandCarousel } from 'modules/brands/list/BrandCarousel'
import { CategorySection } from 'modules/homepage/CategorySection'
import { SearchHeader } from 'modules/homepage/SearchHeader'
import { LastReviewsSection } from 'modules/reviews/home/LastReviewsSection'
import { WriteReviewSection } from 'modules/reviews/home/WriteReviewSection'
import { HomepageThingdrop } from 'modules/thingdrops/HomepageThingdrop'

const ArticleReset = styled.div`
  article > * + * {
    margin-top: 0;
  }
`

const Container = styled(ArticleReset)`
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-bottom: 80px;
`

const Divider = styled.hr`
  all: unset;
  border-top: 1px solid var(--black-15);
`

const Homepage = () => (
  <>
    <PageMeta
      title="Thingtesting - Discover and research the best internet-born brands"
      description="Explore thousands of new online brands and share your honest reviews so everyone on the internet can shop better. Discover the best brands in personal care, home decor, clothing, food, tech and more."
    />
    <Container>
      <SearchHeader />
      <BrandCarousel />
      <Divider />
      <WriteReviewSection />
      <LastReviewsSection />
      <Divider />
      <HomepageThingdrop />
      <Divider />
      <CategorySection />
    </Container>
  </>
)

Homepage.getLayout = function getLayout(page: React.ReactElement) {
  return <Page>{page}</Page>
}

Homepage.getInitialProps = async (ctx: PageContext) => {
  await Promise.allSettled([BrandCarousel.getInitialProps(ctx)])
  return {}
}

export default Homepage
